
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { FinancialYearDDLAPI, MonthDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WardnameHeaderDDL = (props) => {
    const { WardName, setWardName, WLable, HWard, flag } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth  } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // console.log('WardName',Ward)
    const d = new Date();
    let month = d.getMonth();

    const [MonthID, setMonthID] = useState(month + 1)

    useEffect(() => {
        const data = { UserID, token }
        dispatch(WardNameDDLAPI({ data }))
    }, [])

    const { WardDDLData } = useSelector(state => state.WardNameDDLData)

    useEffect(() => {
        handleWardNameDDL()
    }, [WardDDLData])

    const handleWardNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (WardDDLData && WardDDLData.table && WardDDLData.table.length > 0) {
            let list = WardDDLData.table.map((item, index) => ({
                value: item.id,
                label: item.wardName,
            }))
            if (flag == 'Screen') {
                setWardName({
                    DDL: list,
                    ID: HWard,
                    Label: WLable,
                })
                setWard({
                    DDL: list,
                    ID: HWard,
                    Label: WLable,
                })
            } if(Ward.ID !=0){
                setWardName({
                    DDL: list,
                    ID: Ward.ID,
                    Label: Ward.Label,
                })
                setWard({
                    DDL: list,
                    ID: Ward.ID,
                    Label: Ward.Label,
                })
            }
            
            else {
                setWardName({
                    DDL: list,
                    ID: list[0].value,
                    Label: list[0].label,
                })
                setWard({
                    DDL: list,
                    ID: list[0].value,
                    Label: list[0].label,
                })
            }
        }
        else {
            setWardName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    const handleChange=(e)=>{
        setWardName({ ...WardName, ID: e.value, Label: e.label })
        setWard({ ...Ward, ID: e.value, Label: e.label })
    }

    return (
        <div className="form-group" >
            {/* <label className="d-block" htmlFor="NameofDepartment"><b>Month :</b></label> */}
            {/* <select
                value={MonthID}
                onChange={(e) => (
                    setMonthID(e.target.value),
                    setMonth({ ...Month, ID: e.target.value, Label: e.target.name })
                )}
            // onChange={(e) => {
            //     e ?
            //         setMonth({ ...Month, ID: e.target.value, Label: e.label })
            //         :
            //         setMonth({ ...Month, ID: 0, Label: "Select..." })
            // }}
            >
                {
                    Month.DDL.map((item) => (
                        <option value={item.value} name={item.label}>{item.label}</option>
                    ))
                }
            </select> */}

            <Select
                // isRtl={isRtl}
                // styles={{
                //     option: (provided, state) => ({
                //         ...provided,
                //         color: 'black'
                //     })
                // }}
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: state.isFocused ? null : 'transparent',
                        // borderBottomColor: 'black',
                        borderColor: '#878181',
                        boxShadow: 'none',

                    }),
                    option: (provided, state) => ({
                        ...provided,
                        color: 'black'
                    })
                }}
                components={{
                    IndicatorSeparator: () => null
                }}
                value={{ value: WardName.ID, label: WardName.Label }}
                onChange={(e) => {
                    e ?
                       handleChange(e)
                        :
                        setWardName({ ...WardName, ID:  0, Label: "Select..." })

                }}
                options={WardName.DDL}
            />

        </div>
    )
}